import { render, staticRenderFns } from "./HelpSection.vue?vue&type=template&id=98f4c952&"
import script from "./HelpSection.vue?vue&type=script&lang=js&"
export * from "./HelpSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports